import Axios from 'axios';
import qs from 'qs';
import store from '../store';
import router from '../router';
import { ENV } from '../config/constant';
const { VUE_APP_API_HOST_ZLZ: HOST } = ENV;

console.log(HOST);
export const axios = Axios.create({
  baseURL: HOST,
  timeout: 10000,
  withCredentials: false
});
axios.interceptors.request.use(
  requestConfig => {
    const authToken = store.state.login.authToken;
    //localStorage.getItem('authToken');
    if (authToken) {
      requestConfig.headers['auth-token'] = authToken;
    }
    // console.log(requestConfig);
    // 判断post请求
    if (requestConfig.method == 'post' || requestConfig.method == 'put') {
      if (requestConfig.headers['Content-Type'] == 'application/json') {
        requestConfig.data = JSON.stringify(requestConfig.data);
      } else if (!requestConfig.url.includes('/repairRecord/upload')) {
        requestConfig.data = qs.stringify(requestConfig.data);
      }
    }
    return requestConfig;
  },
  error => {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(responseConfig => {
  const token = responseConfig.headers['auth-token'];
  if (token) {
    store.dispatch('login/changeAuthToken', token);
    localStorage.setItem('token', token);
  }

  if (responseConfig.data.code == 501) {
    localStorage.setItem('token', '');
    store.dispatch('login/changeAuthToken', '');
    router.replace({
      name: 'Login',
      query: { redirect: encodeURI(location.href) }
    });
  }
  return responseConfig;
});
